/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicles_EmptyInputs */

const fr_network_vehicles_empty = /** @type {(inputs: Network_Vehicles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun véhicule n'existe avec ces critères de recherche`)
};

const en_network_vehicles_empty = /** @type {(inputs: Network_Vehicles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vehicle matches these search criteria`)
};

/**
* | output |
* | --- |
* | "No vehicle matches these search criteria" |
*
* @param {Network_Vehicles_EmptyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicles_empty = /** @type {((inputs?: Network_Vehicles_EmptyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicles_EmptyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicles_empty(inputs)
	return en_network_vehicles_empty(inputs)
});